//Dialogo de informacion sin items 
import React from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Fade,
} from "@mui/material"
import FeedbackIcon from '@mui/icons-material/Feedback';
import InfoIcon from '@mui/icons-material/Info';

function InfoDialog(props) {
    const { open, onClose, title, message, buttonLabel } = props;
    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="xs"
                fullWidth
                TransitionComponent={Fade}
                transitionDuration={250}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "8px",
                            boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
                            overflow: "visible",
                        },
                    },
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.35)",
                        },
                    },
                }}
            >
                <DialogContent sx={{ px: 3.5, pt: 3.5, pb: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                        <Box
                            sx={{
                                width: 56,
                                height: 56,
                                minWidth: 56,
                                borderRadius: "50%",
                                backgroundColor: "#d32f2f",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <FeedbackIcon sx={{ color: "#ffffff", fontSize: 30, fontWeight: 700 }} />
                        </Box>
                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "1.1rem",
                                    color: "#212121",
                                    mb: 0.5,
                                    lineHeight: 1.4,
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#616161",
                                    fontSize: "0.9rem",
                                    lineHeight: 1.6,
                                }}
                            >
                                {message}
                            </Typography>
                        </Box>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3.5, pb: 2.5, pt: 1.5, justifyContent: "flex-start" }}>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        disableElevation
                        sx={{
                            backgroundColor: "#d32f2f",
                            color: "#ffffff",
                            borderRadius: "6px",
                            px: 3,
                            py: 0.8,
                            fontWeight: 700,
                            fontSize: "0.8rem",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            "&:hover": {
                                backgroundColor: "#b71c1c",
                            },
                        }}
                    >
                        {buttonLabel}
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}

export default InfoDialog
